module.exports = (state, action) => {
  const {
    labelId,
    labelName
  } = action.payload

  if (state.labels[labelId] !== undefined) {
    state.labels[labelId].name = labelName
  } else {
    throw new Error('Cannot create box with id: undefined')
  }
}
